import axios from 'axios'
import * as queryBuilder from 'gql-query-builder'
import get from 'lodash/get'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_STRAPI_API_HOST,
  timeout: 60000,
})

const getHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `bearer ${process.env.REACT_APP_STRAPI_API_KEY}`,
  }

  return { headers }
}

const handleErrors = errors => {
  const message = get(errors, '[0].message')
  throw new Error(message)
}

export const strapiRequest = async (operation, variables = null, fields) => {
  const builtQuery = queryBuilder.query({ operation, variables, fields })

  const getResponse = async () => {
    let response
    try {
      response = await axiosInstance.post('/graphql', builtQuery, Object.assign({}, getHeaders()))
    } catch (error) {
      handleErrors(error)
    }

    // const errors = get(response, 'data.errors')
    // if (errors) {
    //   handleErrors(errors)
    // }

    return get(response, 'data.data')
  }

  const response = await getResponse()

  return response
}



// WEBPACK FOOTER //
// ./src/services/strapi.js